import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Play-block",
  "use": "icon-Play-block-usage",
  "viewBox": "0 0 734.16 830.07",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 734.16 830.07\" id=\"icon-Play-block\"><defs></defs><g id=\"icon-Play-block_图层_2\" data-name=\"图层 2\"><g id=\"icon-Play-block_图层_1-2\" data-name=\"图层 1\"><path class=\"cls-1\" d=\"M0,20.64V809.43c0,15.33,14.28,25.3,26.41,18.42L724.1,432.5c13.43-7.61,13.41-29.28,0-36.86L26.37,2.19C14.25-4.64,0,5.32,0,20.64Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol